import { FC } from 'react'
import { Tooltip } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import styles from './MetricRegressionFlag.less'

interface Props {
  helpText: string
  testId: string
}

const MetricRegressionFlag: FC<Props> = ({ helpText, testId }) => {
  return (
    <Tooltip title={helpText}>
      <WarningOutlined className={styles.icon} data-test-id={testId} />
    </Tooltip>
  )
}

export default MetricRegressionFlag
